// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rights-page {
    min-height: 100vh;
    background: #f8f9fa;
    padding-bottom: 40px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.rights-header {
    background: #fff;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 1px 0 rgba(0,0,0,0.05);
}

.rights-header h1 {
    flex: 1 1;
    text-align: center;
    font-size: 18px;
    margin: 0;
    font-weight: 600;
    color: #333;
}

.back-btn {
    border: none;
    background: none;
    padding: 8px;
    cursor: pointer;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
}

.rights-content {
    padding: 20px;
}

/* Membership Card Style */
.member-card-banner {
    background: linear-gradient(135deg, #2c3e50 0%, #000000 100%);
    border-radius: 16px;
    padding: 24px;
    color: #FFE5B4;
    position: relative;
    overflow: hidden;
    margin-bottom: 24px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}

.member-card-banner::after {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(255, 215, 0, 0.2) 0%, transparent 70%);
    border-radius: 50%;
}

.mc-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.mc-title {
    font-size: 20px;
    font-weight: bold;
    background: linear-gradient(to right, #FFE5B4, #fbbf24);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.mc-status {
    background: rgba(255, 229, 180, 0.2);
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    color: #FFE5B4;
    border: 1px solid rgba(255, 229, 180, 0.3);
}

.mc-info h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
    opacity: 0.9;
}

.mc-info p {
    margin: 4px 0 0;
    font-size: 24px;
    font-weight: bold;
    color: #fff;
}

/* Rights Section */
.rights-section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px;
    padding-left: 12px;
    border-left: 4px solid #333;
}

.rights-grid {
    display: grid;
    gap: 16px;
}

.right-item-card {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.03);
    border: 1px solid rgba(0,0,0,0.02);
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.right-item-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.06);
}

.right-icon-box {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin-right: 16px;
    flex-shrink: 0;
}

.right-info {
    flex: 1 1;
}

.right-info h4 {
    margin: 0 0 6px;
    font-size: 16px;
    color: #333;
}

.right-info p {
    margin: 0;
    font-size: 12px;
    color: #999;
}

.right-btn {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
}

.right-btn.btn-redeem {
    background: #333;
    color: #FFE5B4;
}

.right-btn.btn-redeem:active {
    background: #000;
}

.right-btn.btn-done {
    background: #f0f0f0;
    color: #999;
    cursor: default;
}

/* Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.2s ease-out;
}

.redeem-modal {
    background: #fff;
    width: 85%;
    max-width: 340px;
    border-radius: 20px;
    padding: 24px;
    text-align: center;
    animation: scaleIn 0.2s ease-out cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.modal-icon {
    width: 60px;
    height: 60px;
    background: #f8f9fa;
    border-radius: 50%;
    margin: 0 auto 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
}

.modal-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

.modal-desc {
    font-size: 14px;
    color: #666;
    margin-bottom: 24px;
    line-height: 1.5;
}

.platform-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-bottom: 24px;
}

.platform-option {
    border: 2px solid #f0f0f0;
    border-radius: 12px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.2s;
}

.platform-option.selected {
    border-color: #333;
    background: #fffbf0;
}

.platform-name {
    display: block;
    font-size: 14px;
    font-weight: 500;
}

.modal-confirm-btn {
    width: 100%;
    padding: 12px;
    background: linear-gradient(135deg, #333 0%, #000 100%);
    color: #FFE5B4;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
}

/* Success Animation */
.success-checkmark {
    width: 80px;
    height: 80px;
    margin: 0 auto 16px;
}
.check-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #4bb71b;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #4bb71b;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}
.check-circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #4bb71b;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}
.check-check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}
@keyframes stroke {
    100% { stroke-dashoffset: 0; }
}
@keyframes scale {
    0%, 100% { transform: none; }
    50% { transform: scale3d(1.1, 1.1, 1); }
}
@keyframes fill {
    100% { box-shadow: inset 0px 0px 0px 30px #4bb71b; }
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes scaleIn { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }`, "",{"version":3,"sources":["webpack://./src/components/MemberRightsPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,wIAAwI;AAC5I;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA,0BAA0B;AAC1B;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,+EAA+E;IAC/E,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uDAAuD;IACvD,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uCAAuC;IACvC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,wEAAwE;AAC5E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uDAAuD;IACvD,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,qCAAqC;IACrC,4EAA4E;AAChF;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,8DAA8D;AAClE;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,mEAAmE;AACvE;AACA;IACI,OAAO,oBAAoB,EAAE;AACjC;AACA;IACI,WAAW,eAAe,EAAE;IAC5B,MAAM,+BAA+B,EAAE;AAC3C;AACA;IACI,OAAO,0CAA0C,EAAE;AACvD;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D,qBAAqB,OAAO,qBAAqB,EAAE,UAAU,EAAE,EAAE,KAAK,mBAAmB,EAAE,UAAU,EAAE,EAAE","sourcesContent":[".rights-page {\r\n    min-height: 100vh;\r\n    background: #f8f9fa;\r\n    padding-bottom: 40px;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n}\r\n\r\n.rights-header {\r\n    background: #fff;\r\n    padding: 16px 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 100;\r\n    box-shadow: 0 1px 0 rgba(0,0,0,0.05);\r\n}\r\n\r\n.rights-header h1 {\r\n    flex: 1;\r\n    text-align: center;\r\n    font-size: 18px;\r\n    margin: 0;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n.back-btn {\r\n    border: none;\r\n    background: none;\r\n    padding: 8px;\r\n    cursor: pointer;\r\n    color: #333;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.rights-content {\r\n    padding: 20px;\r\n}\r\n\r\n/* Membership Card Style */\r\n.member-card-banner {\r\n    background: linear-gradient(135deg, #2c3e50 0%, #000000 100%);\r\n    border-radius: 16px;\r\n    padding: 24px;\r\n    color: #FFE5B4;\r\n    position: relative;\r\n    overflow: hidden;\r\n    margin-bottom: 24px;\r\n    box-shadow: 0 10px 30px rgba(0,0,0,0.15);\r\n}\r\n\r\n.member-card-banner::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: -50px;\r\n    right: -50px;\r\n    width: 200px;\r\n    height: 200px;\r\n    background: radial-gradient(circle, rgba(255, 215, 0, 0.2) 0%, transparent 70%);\r\n    border-radius: 50%;\r\n}\r\n\r\n.mc-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.mc-title {\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    background: linear-gradient(to right, #FFE5B4, #fbbf24);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n}\r\n\r\n.mc-status {\r\n    background: rgba(255, 229, 180, 0.2);\r\n    padding: 4px 12px;\r\n    border-radius: 12px;\r\n    font-size: 12px;\r\n    color: #FFE5B4;\r\n    border: 1px solid rgba(255, 229, 180, 0.3);\r\n}\r\n\r\n.mc-info h3 {\r\n    margin: 0;\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n    opacity: 0.9;\r\n}\r\n\r\n.mc-info p {\r\n    margin: 4px 0 0;\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    color: #fff;\r\n}\r\n\r\n/* Rights Section */\r\n.rights-section-title {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin: 0 0 16px;\r\n    padding-left: 12px;\r\n    border-left: 4px solid #333;\r\n}\r\n\r\n.rights-grid {\r\n    display: grid;\r\n    gap: 16px;\r\n}\r\n\r\n.right-item-card {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.03);\r\n    border: 1px solid rgba(0,0,0,0.02);\r\n    display: flex;\r\n    align-items: center;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.right-item-card:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 16px rgba(0,0,0,0.06);\r\n}\r\n\r\n.right-icon-box {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 24px;\r\n    margin-right: 16px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.right-info {\r\n    flex: 1;\r\n}\r\n\r\n.right-info h4 {\r\n    margin: 0 0 6px;\r\n    font-size: 16px;\r\n    color: #333;\r\n}\r\n\r\n.right-info p {\r\n    margin: 0;\r\n    font-size: 12px;\r\n    color: #999;\r\n}\r\n\r\n.right-btn {\r\n    padding: 8px 16px;\r\n    border-radius: 20px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.right-btn.btn-redeem {\r\n    background: #333;\r\n    color: #FFE5B4;\r\n}\r\n\r\n.right-btn.btn-redeem:active {\r\n    background: #000;\r\n}\r\n\r\n.right-btn.btn-done {\r\n    background: #f0f0f0;\r\n    color: #999;\r\n    cursor: default;\r\n}\r\n\r\n/* Modal */\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0,0,0,0.6);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    backdrop-filter: blur(4px);\r\n    animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n.redeem-modal {\r\n    background: #fff;\r\n    width: 85%;\r\n    max-width: 340px;\r\n    border-radius: 20px;\r\n    padding: 24px;\r\n    text-align: center;\r\n    animation: scaleIn 0.2s ease-out cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n}\r\n\r\n.modal-icon {\r\n    width: 60px;\r\n    height: 60px;\r\n    background: #f8f9fa;\r\n    border-radius: 50%;\r\n    margin: 0 auto 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 30px;\r\n}\r\n\r\n.modal-title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    margin-bottom: 8px;\r\n    color: #333;\r\n}\r\n\r\n.modal-desc {\r\n    font-size: 14px;\r\n    color: #666;\r\n    margin-bottom: 24px;\r\n    line-height: 1.5;\r\n}\r\n\r\n.platform-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 12px;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.platform-option {\r\n    border: 2px solid #f0f0f0;\r\n    border-radius: 12px;\r\n    padding: 12px;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.platform-option.selected {\r\n    border-color: #333;\r\n    background: #fffbf0;\r\n}\r\n\r\n.platform-name {\r\n    display: block;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n\r\n.modal-confirm-btn {\r\n    width: 100%;\r\n    padding: 12px;\r\n    background: linear-gradient(135deg, #333 0%, #000 100%);\r\n    color: #FFE5B4;\r\n    border: none;\r\n    border-radius: 12px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n}\r\n\r\n/* Success Animation */\r\n.success-checkmark {\r\n    width: 80px;\r\n    height: 80px;\r\n    margin: 0 auto 16px;\r\n}\r\n.check-icon {\r\n    width: 80px;\r\n    height: 80px;\r\n    border-radius: 50%;\r\n    display: block;\r\n    stroke-width: 2;\r\n    stroke: #4bb71b;\r\n    stroke-miterlimit: 10;\r\n    margin: 10% auto;\r\n    box-shadow: inset 0px 0px 0px #4bb71b;\r\n    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;\r\n}\r\n.check-circle {\r\n    stroke-dasharray: 166;\r\n    stroke-dashoffset: 166;\r\n    stroke-width: 2;\r\n    stroke-miterlimit: 10;\r\n    stroke: #4bb71b;\r\n    fill: none;\r\n    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;\r\n}\r\n.check-check {\r\n    transform-origin: 50% 50%;\r\n    stroke-dasharray: 48;\r\n    stroke-dashoffset: 48;\r\n    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;\r\n}\r\n@keyframes stroke {\r\n    100% { stroke-dashoffset: 0; }\r\n}\r\n@keyframes scale {\r\n    0%, 100% { transform: none; }\r\n    50% { transform: scale3d(1.1, 1.1, 1); }\r\n}\r\n@keyframes fill {\r\n    100% { box-shadow: inset 0px 0px 0px 30px #4bb71b; }\r\n}\r\n\r\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\r\n@keyframes scaleIn { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
